import React, { useEffect, useState } from "react";
import "./Enquiry_form.css";
import { IoClose } from "react-icons/io5";
import { State, City } from "country-state-city";

/* IMAGES */

import { API_BASE_URL } from "../../../config";
import TargetSalesImg from "../../../Assets/Forms/1.png";
import AiFeaturesImg from "../../../Assets/Forms/2.png";
import StoreBrush from "../../../Assets/Forms/3.png";
import BadgeIcon from "../../../Assets/Icons/ai-star.png";

/* SUCCESS FORM */
import SuccessForm from "./SuccessForm/SuccessForm";
import CustomDropdown from "../../Common/CustomDropdown";


const STORAGE_KEY = "fulupo_header_enquiry_data";

const EnquiryModal = ({ isOpen, onClose }) => {
  const [successOpen, setSuccessOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enquiryId, setEnquiryId] = useState("");
  const [errors, setErrors] = useState({});
  const [districtList, setDistrictList] = useState([]);
  const [formData, setFormData] = useState(() => {
    const defaultState = {
      fullName: "",
      storeName: "",
      phone: "",
      district: "",
      state: "",
      details: ""
    };
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        return { ...defaultState, ...parsed };
      } catch (e) {
        console.error("Error parsing saved form data", e);
      }
    }
    return defaultState;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(formData));
  }, [formData]);

  // Initialize cities list when form data is restored from localStorage
  useEffect(() => {
    if (formData.state) {
      const stateObj = State.getStatesOfCountry("IN").find(
        (s) => s.name === formData.state
      );
      if (stateObj) {
        setDistrictList(City.getCitiesOfState("IN", stateObj.isoCode));
      }
    } else {
      setDistrictList([]);
    }
  }, [formData.state]);

  useEffect(() => {
    document.body.style.overflow = isOpen || successOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen, successOpen]);

  useEffect(() => {
    if (!isOpen) {
      setSuccessOpen(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      // Push item to history to intercept back button
      window.history.pushState({ modal: "enquiry" }, "");

      const handlePopState = () => {
        onClose();
      };

      window.addEventListener("popstate", handlePopState);
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen && !successOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let finalValue = value;

    if (name === "phone") {
      finalValue = value.replace(/\D/g, "");
      if (finalValue.length > 10) finalValue = finalValue.slice(0, 10);
    }

    setFormData(prev => ({ ...prev, [name]: finalValue }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: false }));
    }
  };

  const handleStateChange = (stateCode) => {
    // CustomDropdown returns the value directly (isoCode in this case)
    const stateObj = State.getStatesOfCountry("IN").find(
      (s) => s.isoCode === stateCode
    );

    setFormData((prev) => ({
      ...prev,
      state: stateObj ? stateObj.name : "",
      district: "",
    }));

    if (stateCode) {
      setDistrictList(City.getCitiesOfState("IN", stateCode));
    } else {
      setDistrictList([]);
    }

    if (errors.state || errors.district) {
      setErrors((prev) => ({ ...prev, state: false, district: false }));
    }
  };

  const handleCityChange = (cityName) => {
    setFormData((prev) => ({ ...prev, district: cityName }));
    if (errors.district) setErrors((prev) => ({ ...prev, district: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    ["fullName", "storeName", "phone", "district", "state"].forEach(field => {
      if (!formData[field].trim()) newErrors[field] = true;
    });

    if (formData.phone.length !== 10) {
      newErrors.phone = true;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);

    const payload = {
      name: formData.fullName,
      storeName: formData.storeName,
      mobileNumber: formData.phone,
      district: formData.district,
      state: formData.state,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/api/enquiryForm/submit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success) {
        setEnquiryId(result.data._id);
        setSuccessOpen(true);

        // Clear data after success
        localStorage.removeItem(STORAGE_KEY);
        setFormData({
          fullName: "",
          storeName: "",
          phone: "",
          district: "",
          state: "",
          details: ""
        });
      } else {
        alert(result.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      alert("Failed to submit enquiry. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ================= ENQUIRY FORM ================= */}
      {isOpen && !successOpen && (
        <div className="modal-overlay">
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="Enquiry-closed-x" onClick={onClose}>
              <IoClose />
            </button>


            <div className="modal-card">

              {/* LEFT */}
              <div className="modal-left">
                <span className="ai-badge">
                  <img src={BadgeIcon} alt="" className="ai-badge-icon" />
                  AI-Powered Retail
                </span>

                <h1 className="modal-title">
                  Supercharge <br />
                  your{" "}
                  <span className="store-brush-wrap">
                    Store
                    <img src={StoreBrush} className="store-brush-img" alt="" />
                  </span>{" "}
                  with <br /> AI
                </h1>

                <p className="modal-description">
                  Seamlessly manage inventory, predict trends, and automate orders
                  — all from one dashboard.
                </p>

                <div className="stats-stack">
                  <div className="stat-card">
                    <div className="stat-icon-wrapper">
                      <img src={TargetSalesImg} alt="" />
                    </div>
                    <div className="stat-info">
                      <span className="stat-label">Target Sales</span>
                      <span className="stat-value">1M+</span>
                    </div>
                  </div>

                  <div className="stat-card">
                    <div className="stat-icon-wrapper">
                      <img src={AiFeaturesImg} alt="" />
                    </div>
                    <div className="stat-info">
                      <span className="stat-label">AI Features</span>
                      <span className="stat-value">15+</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT */}
              <div className="modal-right">
                <h2 className="form-title">
                  Enquiry with Store <br /> Keeper
                </h2>

                <form onSubmit={handleSubmit}>
                  <input
                    className={`form-input ${errors.fullName ? "error" : ""}`}
                    name="fullName"
                    placeholder="Full Name *"
                    value={formData.fullName}
                    onChange={handleInputChange}
                  />

                  <input
                    className={`form-input ${errors.storeName ? "error" : ""}`}
                    name="storeName"
                    placeholder="Store Name *"
                    value={formData.storeName}
                    onChange={handleInputChange}
                  />

                  <input
                    className={`form-input ${errors.phone ? "error" : ""}`}
                    name="phone"
                    placeholder="Phone Number *"
                    value={formData.phone}
                    onChange={handleInputChange}
                  />

                  <div className="form-row">
                    <div style={{ flex: 1 }}>
                      <CustomDropdown
                        className="dropdown-no-bottom-radius"
                        options={State.getStatesOfCountry("IN").map(s => ({ label: s.name, value: s.isoCode }))}
                        value={State.getStatesOfCountry("IN").find(
                          (s) => s.name === formData.state
                        )?.isoCode || ""}
                        onChange={handleStateChange}
                        placeholder="Select State*"
                        error={errors.state}
                      />
                    </div>

                    <div style={{ flex: 1 }}>
                      <CustomDropdown
                        className="dropdown-no-bottom-radius"
                        options={districtList.map(c => ({ label: c.name, value: c.name }))}
                        value={formData.district}
                        onChange={handleCityChange}
                        placeholder="Select District*"
                        disabled={!formData.state}
                        error={errors.district}
                      />
                    </div>
                  </div>


                  <textarea
                    className="form-input text-area"
                    name="details"
                    placeholder="Additional Details"
                    value={formData.details}
                    onChange={handleInputChange}
                  />

                  <button className="submit-btn" disabled={loading}>
                    {loading ? (
                      <div className="enquiry-loader-container">

                        <div className="enquiry-spinner"></div>
                      </div>
                    ) : (
                      "Submit Enquiry"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}


      {successOpen && <SuccessForm onClose={onClose} enquiryId={enquiryId} />}
    </>
  );
};

export default EnquiryModal;
